/** The board's pan and zoom: screen ↔ board units, zooming around a point, fitting, centring. */
import { BOARD_ZOOM, FIT_MARGIN_PX } from "./constants";
import type { BoardCtx } from "./context";
import { bounds } from "./geometry";
import type { BoardPart } from "./types";

/** The camera's members of the board service. */
export function cameraPart(ctx: BoardCtx): BoardPart<"camera" | "setSize" | "framed" | "toWorld" | "zoomAt" | "pan" | "fit" | "centerOn"> {
  const { camera, setCamera, size } = ctx;
  return {
    camera,
    setSize(w, h) {
      size.w = w;
      size.h = h;
    },
    framed: false,
    toWorld(x, y) {
      const c = camera();
      return { x: (x - c.x) / c.k, y: (y - c.y) / c.k };
    },
    zoomAt(x, y, factor) {
      const c = camera();
      const k = Math.min(BOARD_ZOOM.max, Math.max(BOARD_ZOOM.min, c.k * factor));
      setCamera({ k, x: x - ((x - c.x) * k) / c.k, y: y - ((y - c.y) * k) / c.k });
    },
    pan(dx, dy) {
      const c = camera();
      setCamera({ ...c, x: c.x + dx, y: c.y + dy });
    },
    fit() {
      const all = bounds([...ctx.content().places.values()]);
      ctx.board.framed = true;
      if (!all) return void setCamera({ x: size.w / 2, y: size.h / 2, k: 1 });
      const k = Math.min(BOARD_ZOOM.fitMax, Math.max(BOARD_ZOOM.min, Math.min((size.w - FIT_MARGIN_PX * 2) / all.w, (size.h - FIT_MARGIN_PX * 2) / all.h)));
      setCamera({ k, x: size.w / 2 - (all.x + all.w / 2) * k, y: size.h / 2 - (all.y + all.h / 2) * k });
    },
    centerOn(id) {
      const p = ctx.content().places.get(id);
      if (!p) return;
      const k = camera().k;
      setCamera({ k, x: size.w / 2 - (p.x + p.w / 2) * k, y: size.h / 2 - (p.y + p.h / 2) * k });
    },
  };
}
